import { homebotHostname } from '../constants/env'

export const getFullLocation = () =>
  window.location.origin + window.location.pathname
export const getFullLocationWithQS = () => window.location.href
export const getWindowInnerWidth = () => window.innerWidth
export const getWindowInnerHeight = () => window.innerHeight
export const getSessionStorage = () => window.sessionStorage

export const getIsHomebotDomain = () => {
  const windowHostname = window?.location?.hostname

  if (windowHostname.endsWith) {
    return windowHostname.endsWith(homebotHostname)
  }

  return false
}
